import { GenericForm } from '@neo/blocks/forms/generic-form'
import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import type { SelectOption } from '@neo/primitives/select'
import { identity, pickBy } from 'lodash'
import { PhoneNumberLabel } from 'v2/shared/components/phonenumber-select'
import { TableContainer } from 'v2/shared/components/table-container'
import { usePermissions } from 'v2/shared/hooks/use-permissions'
import { ConvChannels } from 'v2/types/api/conversations'
import { RbacModules, RbacPermissionTypes } from 'v2/types/rbac'
import { generateToastsForMutation } from 'v2/utils/toasts'
import { useAccountNumbersQuery } from '../phone-numbers/queries'
import { useChannelConfigurationMutation, useChannelConfigurationQuery } from '../queries'
import { getSMSChannelFields, SMSChannelDefaultValues } from './channel.config'

export const SMSChannel = () => {
  const { data: formData } = useChannelConfigurationQuery(ConvChannels.MESSAGE)
  const { data: callerIds } = useAccountNumbersQuery('simple', ConvChannels.MESSAGE, true)
  const { mutate, isPending } = useChannelConfigurationMutation(ConvChannels.MESSAGE)
  const { hasPermission } = usePermissions()

  // Options for the select dropdowns
  const options = callerIds?.map<SelectOption>((callerId) => {
    return {
      label: <PhoneNumberLabel phoneNumber={callerId} />,
      searchValue: `${callerId.name_tag || ''} ${callerId.number}`,
      value: callerId.id,
    }
  })

  return (
    <TableContainer>
      <GenericForm<typeof SMSChannelDefaultValues>
        defaultValues={formData || SMSChannelDefaultValues}
        id="sms-channel-settings"
        isSubmitting={isPending}
        submitText={isPending ? 'Saving...' : 'Save'}
        includeSubmitButton={hasPermission(RbacModules.channelMessage, RbacPermissionTypes.create)}
        className="gap-4"
        fields={
          getSMSChannelFields(options || []) as GenericFieldConfig<typeof SMSChannelDefaultValues>
        }
        onSubmit={(values) =>
          mutate(
            pickBy(values, identity) as typeof SMSChannelDefaultValues,
            generateToastsForMutation(
              { title: 'Success', description: 'SMS settings updated successfully' },
              { title: 'Error', description: 'Failed to update SMS settings' },
            ),
          )
        }
      />
    </TableContainer>
  )
}
